// extracted by mini-css-extract-plugin
export var subtitle = "_9z-2";
export var title = "_9z-0";
export var titleNoWrap = "_9z-1";